/**
 * 支払キュー(payQueue.ts)の読み込み(2026-10-23)。読むだけで書き込みはしない。
 * まだ支払っていない状態(承認前・支払い待ち)の取引を読む。収入・資金移動は payQueue.ts の buildPayQueue() が外す。
 * 読める人(権限ルール): 経理・管理者・承認者は全件
 */
import { collection, getDocs, limit, query, where, type QueryDocumentSnapshot } from 'firebase/firestore';
import { getDb } from '@core/lib/firebase';
import type { Transaction } from '@core/lib/types';
import { QUEUE_STATUSES } from './payQueue';

/** 一度に読む上限。超えたら画面に「一部だけ表示」と出す */
export const QUEUE_LIMIT = 1000;

function withId(snap: QueryDocumentSnapshot): Transaction {
  return { id: snap.id, ...(snap.data() as object) } as Transaction;
}

export async function fetchPayQueueTransactions(): Promise<{ rows: Transaction[]; truncated: boolean }> {
  const snap = await getDocs(
    query(collection(getDb(), 'transactions'), where('status', 'in', QUEUE_STATUSES), limit(QUEUE_LIMIT)),
  );
  return { rows: snap.docs.map(withId), truncated: snap.size >= QUEUE_LIMIT };
}
